<template>
  <v-footer
    app
    class="pt-1"
    height="24"
    color="Neutral"
    style="border-top: 1px solid var(--v-Neutral-darken1) !important"
  >
    <v-spacer></v-spacer>
    <v-avatar icon tile size="14" class="mr-2">
        <v-img
          src="../assets/images/NewAvantLogo.png"
          alt="DIVA"
        ></v-img> </v-avatar
      >
    <span class="footer-title">
      DIVA Corporation &copy; {{ new Date().getFullYear() }}
    </span>
     
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
.footer-title {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  /* identical to box height, or 150% */

  color: #666666;
}
</style>